import * as React from "react"
import type { SVGProps } from "react"
const SvgCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3 19.22q0 .83.59 1.4.59.6 1.41.6h10q.42 0 .71-.3a1 1 0 0 0 .29-.7 1 1 0 0 0-.29-.72 1 1 0 0 0-.71-.29H5v-10a1 1 0 0 0-.29-.7A1 1 0 0 0 4 8.2a1 1 0 0 0-.71.3 1 1 0 0 0-.29.7zm6-4v-9h9v9zm-1.41 1.4q.59.6 1.41.6h9q.83 0 1.41-.6.6-.59.59-1.4v-9q0-.84-.59-1.42A2 2 0 0 0 18 4.21H9q-.82 0-1.41.6A2 2 0 0 0 7 6.2v9q0 .82.59 1.42"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgCopy
